(function () {
  if (window.__bsDW) return;
  window.__bsDW = true;

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('.bs-faq-q');
    if (btn) {
      var item = btn.parentElement;
      var open = item.classList.toggle('active');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var a = ev.target.closest('a[href="#planes"]');
    if (a) {
      var t = document.getElementById('planes');
      if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  function revealInit(root) {
    var els = (root || document).querySelectorAll('.bs-reveal:not(.bs-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bs-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bs-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function stickyInit() {
    var sticky = document.getElementById('bsStickyCta');
    if (!sticky) return;
    window.addEventListener('scroll', function () {
      var finalSection = document.querySelector('.bs-final');
      var pastHero = window.scrollY > 700;
      var nearEnd = false;
      if (finalSection) { nearEnd = finalSection.getBoundingClientRect().top < window.innerHeight; }
      sticky.classList.toggle('show', pastHero && !nearEnd);
    }, { passive: true });
  }

  function boot() { revealInit(document); stickyInit(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bs-reveal').forEach(function (el) { el.classList.add('bs-in'); });
  });
})();
